import type {ReactElement} from 'react';
import {ColorPalettePanel} from '@Components/color-palettes/color-palette-panel/color-palette-panel';
import {PALETTE_APPLIED_EVENT} from '@/types/email-maker-global.constants';
import {RightPanelOverlayHeader} from '../../components/right-panel-overlay-header/right-panel-overlay-header';
import type {ColorPaletteViewProps} from './color-palette-view.types';
import styles from './color-palette-view.module.scss';

export function ColorPaletteView({appliedColorPalette, onBack, onColorPaletteSelect, onPillSelected, onSearchSubmit}: ColorPaletteViewProps): ReactElement {
  return (
    <div className={styles.view}>
      <RightPanelOverlayHeader title={window.i18next.t('pmwjs_styles')} backAriaLabel={window.i18next.t('pmwjs_back')} onBack={onBack} />
      <div className={styles.panel}>
        <ColorPalettePanel
          className={styles.paletteRoot}
          appliedColorPalette={appliedColorPalette}
          colorPaletteAppliedEvent={PALETTE_APPLIED_EVENT}
          onColorPaletteSelect={onColorPaletteSelect}
          onPillSelected={onPillSelected}
          onSearchSubmit={onSearchSubmit}
        />
      </div>
    </div>
  );
}
